import * as utilTypes from '../types/Util';
import {INITIAL_STATE} from './state/Util'; 

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case utilTypes.GET_COMPLAINTS_TYPES_DICTIONARY_REQUEST:
            return { 
                ...state, 
                complaintTypes: [],
            };
        case utilTypes.GET_COMPLAINTS_TYPES_DICTIONARY_SUCCESS:
            return { 
                ...state, 
                complaintTypes: action.payload,
            };
        case utilTypes.GET_CUSTOMERS_TYPES_DICTIONARY_REQUEST:
            return { 
                ...state, 
                customerTypes: [],
            };
        case utilTypes.GET_CUSTOMERS_TYPES_DICTIONARY_SUCCESS:
            return { 
                ...state, 
                customerTypes: action.payload,
            };
        case utilTypes.GET_QUANTITY_CORRECTIONS_PROPOSALS_DICTIONARY_REQUEST:
            return { 
                ...state, 
                quantityCorrectionsProposals: [],
            };
        case utilTypes.GET_QUANTITY_CORRECTIONS_PROPOSALS_DICTIONARY_SUCCESS:
            return { 
                ...state, 
                quantityCorrectionsProposals: action.payload,
            };
        case utilTypes.GET_TERM_OF_USE_URL_SUCCESS:
            return { 
                ...state, 
                termOfUseURL: action.payload,
            };
        case utilTypes.GET_ALLOW_MULTIPLE_COMPLAINT_POSITION_SUCCESS:
            return { 
                ...state, 
                allowMultiplePositionsForComplaint: action.payload,
            };
        case utilTypes.GET_IS_MY_COMPANY_NOT_FOUND_CHECKBOX_VISIBLE_SUCCESS:
            return { 
                ...state,
                isMyCompanyNotFoundCheckBoxVisible: action.payload,
            };
        case utilTypes.GET_IS_SERIAL_NUMBER_TOOLTIP_VISIBLE_SUCCESS:
            return { 
                ...state,
                isSerialNumberTooltipVisible: action.payload,
            };
        case utilTypes.GET_COURIERS_REQUEST:
            return { 
                ...state,
                couriers:[],
            };
        case utilTypes.GET_COURIERS_SUCCESS:
            return { 
                ...state,
                couriers:action.payload,
            };
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Util.js